import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';

import VideoVisitBtn from '../../../Healthboard/Components/VideoVisitBtn';
import Button from '../../../Button';
import Paper from '../../../Paper';
import styles from './styles.styl';

function Intro({
  formatMessage,
  onStartTestVisit,
  onStartVideoVisit,
  virtualCallEnabled,
}) {
  return (
    <Paper className={styles.root}>
      <h3 className={styles.title}>
        {formatMessage({ id: 'virtualVisit.test.startsSoon' })}
      </h3>
      <p className={styles.subtitle}>
        {formatMessage({ id: 'virtualVisit.test.desc' })}
      </p>
      <Button color="accent" raised onClick={onStartTestVisit}>
        {formatMessage({ id: 'virtualVisit.test.check' })}
      </Button>
      <Fragment>
        <p className={styles.desc}>
          {formatMessage({ id: 'virtualVisit.test.continue' })}
        </p>
        <VideoVisitBtn
          type="primary"
          onStartVideoVisit={onStartVideoVisit}
          disabled={!virtualCallEnabled}
        />
      </Fragment>
    </Paper>
  );
}

Intro.propTypes = {
  formatMessage: PropTypes.func,
  onStartTestVisit: PropTypes.func,
  onStartVideoVisit: PropTypes.func,
  virtualCallEnabled: PropTypes.bool,
};

export default Intro;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/Components/Intro/index.jsx